<template>
  <div>
    页面开发中。。。
  </div>

</template>

<script>
    export default {
        name: "wait"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/wait.vue